import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ValueOf } from '@/types/common';

export const REGISTRATION_FORM_STEP = {
    Email: 'email',
    Code: 'code',
    Password: 'password',
    EmailRecovery: 'emailRecovery',
    CodeRecovery: 'codeRecovery',
    PasswordRecovery: 'passwordRecovery',
} as const;

export type RegistrationFormStepT = ValueOf<typeof REGISTRATION_FORM_STEP>;

export interface AuthSliceIF {
    registrationFormStep: RegistrationFormStepT;
}

const initialState: AuthSliceIF = {
    registrationFormStep: REGISTRATION_FORM_STEP.Email,
};

export const authSlice = createSlice({
    name: 'authSlice',
    initialState,
    reducers: {
        setRegistrationFormStep: (
            state,
            action: PayloadAction<RegistrationFormStepT>,
        ) => {
            state.registrationFormStep = action.payload;
        },
    },
});

export const { setRegistrationFormStep } = authSlice.actions;
